import { CommonRequestAttrs } from "../common";

export class UsersIdDto extends CommonRequestAttrs {
    appId?: number;
    unitId?:number
    constructor(username: string, userId: number,appId?:number,unitId?:number) {
        super(username, userId);
        this.appId = appId;
        this.unitId = unitId
    }

}